import React from "react";
import styled from "styled-components";

import Button from "../../button/Button";

interface CompleteStepProps {
  onClose: () => void;
}

const StepRoot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 48px 0;
  text-align: center;
`;

const Headline = styled.div.attrs({ className: "heading-16" })`
  color: var(--soremo-text);
`;

const SubText = styled.div.attrs({ className: "bodytext-13" })`
  color: var(--soremo-light-gray);
`;

const CompleteStep: React.FC<CompleteStepProps> = ({ onClose }) => (
  <StepRoot>
    <Headline>オファーを送信しました</Headline>
    <SubText>相手からの返答をお待ちください。</SubText>
    <Button onClick={onClose}>DM に戻る</Button>
  </StepRoot>
);

export default CompleteStep;
